import { render } from "./friendsTab.vue?vue&type=template&id=3fcd2e6f"
import script from "./friendsTab.vue?vue&type=script&lang=js"
export * from "./friendsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__